import { City } from "./regions";
import { TRecipientData } from "../stores/RecipientStore";

export interface ISchedule {
  id: number;
  dow: string;
  start: string;
  end: string;
}

export interface Needs {
  blood_station: number;
  id: number;
  is_published: boolean;
  blood_group: string[];
}

export interface IPhoneNumbers {
  id: number;
  phone: string;
  comment: string;
}

export interface IDetailBloodStation {
  id?: number;
  blood_status?: string;
  city_id?: number;
  city?: City;
  has_blood_group?: boolean;
  schedule?: ISchedule[];
  phone_numbers?: IPhoneNumbers[];
  lat?: number;
  lng?: number;
  title?: string;
  address?: string;
  site?: string;
  phones?: string;
  email?: string;
  worktime?: string;
  without_registration?: boolean;
  with_typing?: boolean;
  for_moscow?: boolean;
  closed?: boolean;
  priority?: number;
  addressneed?: TRecipientData[];
  blood_group: string[];
}

export default class DetailBloodStation {
  id?: number;
  blood_status?: string;
  city_id?: number;
  city?: City;
  addressneed?: TRecipientData[];
  has_blood_group?: boolean;
  schedule?: ISchedule[];
  phone_numbers?: IPhoneNumbers[];
  lat?: number;
  lng?: number;
  title?: string;
  address?: string;
  site?: string;
  phones?: string;
  email?: string;
  worktime?: string;
  without_registration?: boolean;
  with_typing?: boolean;
  for_moscow?: boolean;
  closed?: boolean;
  priority?: number;
  blood_group: string[];

  constructor(DetailBS: IDetailBloodStation) {
    this.id = DetailBS?.id;
    this.blood_status = DetailBS?.blood_status;
    this.city_id = DetailBS?.city_id;
    this.city = DetailBS?.city;
    this.addressneed = DetailBS?.addressneed;
    this.has_blood_group = DetailBS?.has_blood_group;
    this.schedule = DetailBS?.schedule
      ? DetailBS?.schedule.map((item) => item)
      : null;
    this.phone_numbers = DetailBS?.phone_numbers
      ? DetailBS?.phone_numbers.map((item) => item)
      : null;
    this.lat = DetailBS?.lat;
    this.lng = DetailBS?.lng;
    this.title = DetailBS?.title;
    this.address = DetailBS?.address;
    this.site = DetailBS?.site;
    this.phones = DetailBS?.phones;
    this.email = DetailBS?.email;
    this.worktime = DetailBS?.worktime;
    this.without_registration = DetailBS?.without_registration;
    this.with_typing = DetailBS?.with_typing;
    this.for_moscow = DetailBS?.for_moscow;
    this.closed = DetailBS?.closed;
    this.priority = DetailBS?.priority;
    this.blood_group = DetailBS?.blood_group;
  }
}
